/**
Właściwy modół dla katalogu jest w katalogu
 */
app.service('wcClientClipboard',function() {
	
});
